/* Original name @uswitch/trustyle.input-alert */

import * as React from 'react'
import { useThemeUI } from 'theme-ui'

const ARROW_SIZE = 8

export const InputAlert = ({ type, children, ...props }) => {
  const { theme } = useThemeUI()

  const padding = theme?.elements?.['input-alert']?.padding
  const notificationColor = theme?.elements?.['input-alert']?.notificationColor
  const alertColor = theme?.elements?.['input-alert']?.alertColor

  return (
    <div
      {...props}
      sx={{
        variant: 'elements.input-alert',
        marginTop: `calc(${ARROW_SIZE}px + ${padding}px)`,
        backgroundColor: type === 'alert' ? alertColor : notificationColor,
        '&:before': {
          variant: 'elements.input-alert.before',
          top: -ARROW_SIZE,
          borderLeft: `${ARROW_SIZE}px solid transparent`,
          borderRight: `${ARROW_SIZE}px solid transparent`,
          borderBottomWidth: ARROW_SIZE,
          borderBottomColor: type === 'alert' ? alertColor : notificationColor,
        },
      }}
    >
      {children}
    </div>
  )
}

export default InputAlert
